import React from 'react';
import { Controller } from 'react-hook-form';

import { INumberInputProps, NumberInput } from '../../components';
import { FormError } from '../FormError';
import { FormField } from '../FormField';
import { FormLabel } from '../FormLabel';

export interface INumberFieldProps extends INumberInputProps {
    name: string;
    label?: string;
}

export const NumberField: React.FC<INumberFieldProps> = ({ id, name, label, ...inputProps }) => {
    return (
        <Controller
            name={name}
            render={({ field: { onChange, ...fieldProps }, fieldState: { error } }) => (
                <FormField
                    labelSlot={label && <FormLabel htmlFor={id || name}>{label}</FormLabel>}
                    errorSlot={error && <FormError>{error?.message}</FormError>}
                >
                    <NumberInput
                        id={id || name}
                        error={!!error}
                        onChange={(value) => {
                            if (value === undefined) {
                                return onChange(null);
                            }
                            onChange(value);
                        }}
                        {...fieldProps}
                        {...inputProps}
                    />
                </FormField>
            )}
        />
    );
};
